export default /**
eeeeeeeeeeeeeee *
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
eeeeeeeeeeeeeee
                */
(t) => {
    const { colors } = t['foundations-library']
    return {
        stepperWrapper: {
            display: 'flex',
            '&.stepper-wrapper--center': { justifyContent: 'center' },
            '&.stepper-wrapper--left': { justifyContent: 'left' },
            '&.stepper-wrapper--right': { justifyContent: 'right' }
        },
        stepper: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            '&.stepper--narrow': { maxWidth: '50%' },
            '& .stepper-step--line': {
                content: '" "',
                height: '1px',
                opacity: 0.65,
                backgroundColor: colors.neutral[200],
                width: '100%',
                marginTop: '22px'
            },
            '&.stepper--left': {
                '& .stepper-step--line': {
                    marginLeft: '10px',
                    marginRight: '10px'
                }
            },
            '&.stepper--bottom': {
                '& .stepper-step--line': {
                    marginLeft: '-10px',
                    marginRight: '-10px'
                }
            },
            '& .stepper--dots-wrapper': {
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                width: '100%',
                '& .stepper--step-dot': {
                    height: '14px',
                    width: '14px',
                    borderRadius: '15px',
                    backgroundColor: 'rgba(218, 217, 217, 0.65)',
                    cursor: 'pointer',
                    '&.stepper-dot--active': {
                        backgroundColor: colors.tertiary[500]
                    }
                }
            }
        }
    }
}
